import { render, staticRenderFns } from "./week-calendar.component.vue?vue&type=template&id=1ef57f56&"
import script from "./week-calendar.component.vue?vue&type=script&lang=ts&"
export * from "./week-calendar.component.vue?vue&type=script&lang=ts&"
import style0 from "./week-calendar.component.vue?vue&type=style&index=0&id=1ef57f56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports